import { useHolidayMatchBannerConfig } from '@fhs/loyalty/src/components/holiday-match-banner';
import {
  LoyaltyHomepage,
  PersonalizedHomepage,
  useIsLoyaltyHomepageEnabled,
  useIsPersonalizedHomepageEnabled,
} from '@fhs/loyalty-homepage';
import { MqSwitch, createMqStyles } from '@fhs/ui';

import { HomeCard } from './home-card';
import { ScreenHomeDesktop } from './screen-home-desktop';
import { ScreenHomeMobile } from './screen-home-mobile';
import { selectHomepageBanner } from './select-homepage-banner';
import { ScreenHomeProps } from './types';

export { ScreenHomeProps } from './types';

export function ScreenHome(props: ScreenHomeProps) {
  const mqStyles = useMqStyles();
  const isPersonalizedHomepageEnabled = useIsPersonalizedHomepageEnabled();
  const isLoyaltyHomepageEnabled = useIsLoyaltyHomepageEnabled();
  const holidayBanner = useHolidayMatchBannerConfig();
  const homepageBanner = selectHomepageBanner({
    alert: props.alert,
    holidayBannerEnabled: holidayBanner.enabled,
  });

  if (isPersonalizedHomepageEnabled) {
    return (
      <PersonalizedHomepage
        legacyHomepageAlert={homepageBanner}
        legacyHomeCard={
          <HomeCard
            style={mqStyles.container}
            logReorderCardPress={props.logReorderCardPress}
            displayedOrder={props.displayedOrder}
            displayedOrderCardLoading={props.displayedOrderCardLoading}
            redirectPath={props.redirectPath}
            onReorder={props.onReorder}
            reorderLoading={props.reorderLoading}
            isLoadingChallenges={props.isLoadingChallenges}
            loyaltyUserReady={props.loyaltyUserReady}
            isDesktop={props.isDesktop}
            challengeHomeCardProps={props.challengeHomeCardProps}
            noEmptyState
          />
        }
      />
    );
  }

  if (isLoyaltyHomepageEnabled) {
    return (
      <LoyaltyHomepage
        {...props}
        legacyHomepageAlert={homepageBanner}
        legacyHomeCard={
          <HomeCard
            style={mqStyles.container}
            logReorderCardPress={props.logReorderCardPress}
            displayedOrder={props.displayedOrder}
            displayedOrderCardLoading={props.displayedOrderCardLoading}
            redirectPath={props.redirectPath}
            onReorder={props.onReorder}
            reorderLoading={props.reorderLoading}
            isLoadingChallenges={props.isLoadingChallenges}
            loyaltyUserReady={props.loyaltyUserReady}
            isDesktop={props.isDesktop}
            challengeHomeCardProps={props.challengeHomeCardProps}
            doublePointsMondayBanner={props.doublePointsMondayBanner}
            noEmptyState
          />
        }
      />
    );
  }

  return (
    <MqSwitch
      $base={() => <ScreenHomeMobile {...props} />}
      $gteDesktop={() => <ScreenHomeDesktop {...props} />}
    />
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      maxWidth: 1400,
      width: '100%',
      marginHorizontal: 'auto',
      paddingHorizontal: 16,
    },
    $gteDesktop: {
      paddingHorizontal: 32,
    },
  },
});
